import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb, Icon } from 'antd'
import '../assets/css/trustService.css'
// import  serviceConstruct from '../assets/images/assetConstruct.svg'
import trustService from '../assets/images/trustService.svg'
import trustGraph from '../assets/images/trustGraph.png'
// import serviceMain from '../assets/images/serviceMain.svg'

class FundService extends Component {
    render () {
        return (
            <div>
                <div className="banner-item banner-trust">
                    <div className="l-container">
                        <h2>托管服务</h2>
                    </div>
                </div>
                <div className="page-title l-container">
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item><a href="/gs/">首页</a></Breadcrumb.Item>
                        <Breadcrumb.Item><a href="/gs/business/">我们的业务</a></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to="/">资产托管与基金服务</Link></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to="/trustService">托管服务</Link></Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className="page-content-trust">
                    <div className="content-panel">
                        <div className="l-container">
                            <h2>托管服务</h2>
                            <div className="trust-service-box">
                                <div>
                                <p>
                                资产托管服务是指我司依据法律法规的规定和合同协议的约定，作为独立第三方，为管理人依法发行的基金产品提供资产保管、清算交割、估值复核、投资监督、信息披露等专业的资产托管服务。
                                </p>
                                <p>
                                    托管产品类型：包括公募基金、私募基金、基金专户、券商资管、期货资管等产品
                                </p>
                                </div>
                                <div>
                                    <div className="img-wrap">
                                        <img src={trustGraph} alt="trustGraph"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content-panel">
                        <div className="l-container">
                            <h2>服务内容</h2>
                            <div className="service-content-box">
                                <div>
                                    <div className="box-item">
                                        <h4>资产保管</h4>
                                        <p>按照法律法规规定及合同协议的约定，安全保管基金财产。</p>
                                    </div>
                                    <div className="box-item">
                                        <h4>资金清算</h4>
                                        <p>按照合同协议的约定，根据管理人或其授权人的资金划拨指令和其他必要材料（如需），及时办理清算、交割事宜。</p>
                                    </div>
                                    <div className="box-item">
                                        <h4>估值核算</h4>
                                        <p>按照法律法规规定及合同协议的约定，复核基金管理人计算的产品资产净值。</p>
                                    </div>
                                </div>
                                <div>
                                    <div className="box-item">
                                        <h4>投资监督</h4>
                                        <p>按照法律法规规定及合同协议的约定，监督管理人的投资运作。</p>
                                    </div>
                                    <div className="box-item">
                                        <h4>信息披露</h4>
                                        <p>根据相关法律法规和基金合同约定，复核基金管理人编制的基金定期报告中的财务数据。</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="content-panel">
                        <div className="l-container">
                            <h2>主要服务内容</h2>
                            <div className="service-main">
                                <div><img src={serviceMain} alt="serviceMain"/></div>
                                <div>
                                    <h6>国信证券开展资产托管业务，可以为客户提供下列托管服务：</h6>
                                    <ul>
                                        <li><span>◉</span>安全保管基金资产</li>
                                        <li><span>◉</span>资产估值、净值复核和会计核算</li>
                                        <li><span>◉</span>开立和管理资产托管账户</li>
                                        <li><span>◉</span>办理与资产托管业务有关的信息披露事项</li>
                                        <li><span>◉</span>执行投资指令，办理结算、交割</li>
                                        <li><span>◉</span>保管资产托管业务档案资料</li>
                                        <li><span>◉</span>按法律法规和合同约定进行投资监督</li>
                                        <li><span>◉</span>法律、行政规则以及中国证监会规定的或者基金合同/托管协议约定的</li>
                                        <li>其他事项</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="content-panel">
                    </div>
                    {/* <div className="content-panel">
                        <div className="l-container">
                            <h2>资产托管服务架构</h2>
                            <div className="service-construct">
                                <img src={serviceConstruct} alt="serviceConstruct"/>
                            </div>
                        </div>
                    </div> */}
                    <div className="content-panel">
                        <div className="l-container">
                            <h2>业务资格</h2>
                            <div className="service-qualification">
                                <div>
                                    <img src={trustService} alt="trustService"/>
                                    <p>
                                    国信证券是首批获得证券投资基金托管资格【证监许可[2013]1666号】的券商之一，借助综合金融优势、专业高效的服务水平，为基金公司、证券公司、期货公司、私募机构等资产管理人所发行的产品提供高效、便捷的资产托管服务。
                                    </p>
                                </div>
                                <div>
                                    <div className="ant-btn"><a href="http://www.csrc.gov.cn/pub/zjhpublic/G00306205/201509/t20150924_284313.htm">查看业务资格<Icon type="right" /></a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default FundService
